import { z } from "zod";
import { GroupBaseSchema } from "../generated/Group";

export const getUserSchema = z.object({
  id: z.string().uuid(),
  group_id: z.string().uuid(),
  login_id: z.string(),
  name: z.string(),
  authority: z.number(),
  deleted_at: z.number().nullable(),
  Group: GroupBaseSchema.base
});
export const getUserRowSchema = getUserSchema.array();
export type getUserType = z.infer<typeof getUserSchema>;
export type getUserRowType = z.infer<typeof getUserRowSchema>;
